import { useQuery } from '@hooks/reactQuery';

import { getOptionsCells } from '@api/kpi';

import { ETechnologiesValues, EUserRoles, EVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { OPTIONS_T_4G_FDD_LIMENET, OPTIONS_T_4G_TDD_LIMENET, OPTIONS_T_5G_LIMENET } from '@constants/queryKeys';

interface IUseQueryOptionsCellsLimenetProps {
	isKpiView: boolean;
	availableVendors: string[];
}

export const useQueryOptionsCellsLimenet = (props: IUseQueryOptionsCellsLimenetProps) => {
	const { isKpiView, availableVendors } = props;
	const isLimenetVendor = availableVendors.includes(EVendorsValues.limenet);

	const {
		data: options4GTddLimenet,
		isInitialLoading: isLoadingOptions4GTddLimenet,
	} = useQuery({
		queryKey: [OPTIONS_T_4G_TDD_LIMENET],
		queryFn: () => getOptionsCells({
			technology: ETechnologiesValues.T_4G_TDD,
			vendor: EVendorsValues.limenet,
		}),
		allowedRoles: [
			EUserRoles.networkOperatorKpiViewer,
			EUserRoles.networkOperatorKpiUpdater,
		],
		enabled: [isKpiView, isLimenetVendor],
		...refetchOptions,
	});

	const {
		data: options4GFddLimenet,
		isInitialLoading: isLoadingOptions4GFddLimenet,
	} = useQuery({
		queryKey: [OPTIONS_T_4G_FDD_LIMENET],
		queryFn: () => getOptionsCells({
			technology: ETechnologiesValues.T_4G_FDD,
			vendor: EVendorsValues.limenet,
		}),
		allowedRoles: [
			EUserRoles.networkOperatorKpiViewer,
			EUserRoles.networkOperatorKpiUpdater,
		],
		enabled: [isKpiView, isLimenetVendor],
		...refetchOptions,
	});

	const {
		data: options5GLimenet,
		isInitialLoading: isLoadingOptions5GLimenet,
	} = useQuery({
		queryKey: [OPTIONS_T_5G_LIMENET],
		queryFn: () => getOptionsCells({
			technology: ETechnologiesValues.T_5G,
			vendor: EVendorsValues.limenet,
		}),
		allowedRoles: [
			EUserRoles.networkOperatorKpiViewer,
			EUserRoles.networkOperatorKpiUpdater,
		],
		enabled: [isKpiView, isLimenetVendor],
		...refetchOptions,
	});

	return {
		options4GTddLimenet,
		isLoadingOptions4GTddLimenet,
		options4GFddLimenet,
		isLoadingOptions4GFddLimenet,
		options5GLimenet,
		isLoadingOptions5GLimenet,
	};
};
